<template>
  <div v-show="isActive" class="space-y-6">
    <!-- En-tête de l'étape -->
    <div class="border-b border-gray-200 pb-2">
      <h3 class="text-xl font-semibold text-gray-900">
        {{ stepNumber }}. {{ title }}
      </h3>
      <p v-if="description" class="text-sm text-gray-600 mt-1">
        {{ description }}
      </p>
    </div>
    
    <!-- Contenu de l'étape -->
    <div class="space-y-4">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StepComponentProps } from '@/types/sellerRegister';

defineProps<StepComponentProps>();
</script>
